// src/components/CookieSettingsLink.js
import React from 'react';
import { openCookieSettings } from '../utils/consent';

const CookieSettingsLink = ({ className }) => (
  <a
    href="#!"
    className={className}
    onClick={(e) => {
      e.preventDefault();
      openCookieSettings();
    }}
  >
    Cookie-instellingen
  </a>
);

export default CookieSettingsLink;
